<template>
  <div>
    <forget-password-ctrl :propsList="propsList" @returnToLogin="returnToLogin" :isExistUsername='isExistUsername' @sendSmsCode="sendSmsCode" @onIsExistUsername="onIsExistUsername" @resetPassword="resetPassword"></forget-password-ctrl>
  </div>
</template>
<script>
import ForgetPasswordCtrl from '../Ctrl/ForgetPasswordCtrl.vue'
import { ForgetPasswordLogic } from '../../Logic/ForgetPasswordLogic.js'
export default {
  components: { ForgetPasswordCtrl },
  props: {
    propsList: {
      type: Object
    }
  },

  data () {
    return {
      isExistUsername: false
    }
  },
  methods: {
    sendSmsCode (value) {
      if (value.countFlag) {
        ForgetPasswordLogic.recoverPassword(value.username, 'mobile')
          .then(res => {
            this.$message.success('短信验证码已经发送')
          })
          .catch(() => {
            this.$message.error('短信验证码发送失败，请重新获取')
          })
      }
    },
    onIsExistUsername (value) {
      if (value !== '') {
        ForgetPasswordLogic.isUsernameExist(value)
          .then(() => {
            this.isExistUsername = true
          })
          .catch(error => {
            console.log('isUsernameExist66666----', error)
            this.isExistUsername = false
            this.$message.error('用户名已存在')
          })
      }
    },
    resetPassword (form) {
      ForgetPasswordLogic.isUsernameExist(form.username)
        .then(res => {
          ForgetPasswordLogic.resetPassword(
            form.username,
            form.password,
            form.code
          )
            .then(res => {
              this.$emit('resetPasswordSuccess', res)
            })
            .catch(error => {
              this.$emit('resetPasswordFailed', error)
            })
        })
        .catch(() => {
          this.$message.error('用户已存在')
        })
    },
    returnToLogin () {
      this.$emit('returnToLogin')
    }
  }
}
</script>



// WEBPACK FOOTER //
// third_party/common_app/LoginModule/View/Area/ForgetPasswordArea.vue